export default __webpack_public_path__ + "static/media/Boots of the Sundered Skies.e9bf9ad7.jpg";